<template>
  <div
    style="min-height: calc(100vh - 160px)"
    v-loading="homeLoading"
    element-loading-text="数据处理中......"
  >
    <div>
      <div>
        <div class="title">
          <div class="title--newFont">{{ $t("发料明细") }}</div>
          <div style="text-align: right">
            <el-button class="btnTwo" @click="backHome" size="small">{{
              $t("返回")
            }}</el-button>
            <el-button
              v-if="canCancelReceive"
              class="btnCancel"
              size="small"
              :loading="cancelSubmitting"
              @click="handleCancelReceive"
            >{{ $t("撤销收料") }}</el-button>
            <el-button
              v-if="canReceive"
              class="btnOne"
              size="small"
              @click="openReceiveDialog"
            >{{ $t("收料") }}</el-button>
          </div>
        </div>
        <div v-if="docData.statusCheck == 1">
          <div class="checkImg">
            <img
              style="max-width: 100%; max-height: 100%"
              src="@/assets/images/examine.png"
            />
          </div>
        </div>
      </div>
      <hr />
      <!-- 操作栏 -->
      <div style="margin: 10px 0; font-size: 16px; font-weight: bold; color: #1476C3">
        丨{{ $t("基本信息") }}
      </div>
      <div style="margin-bottom: 10px">
        <el-descriptions
          direction="horizontal"
          :key="key"
          :size="'small'"
          :column="5"
          :label-style="labelStyle"
          :contentStyle="contentStyle"
          border
        >
          <el-descriptions-item>
            <template slot="label">{{ $t("发料单号") }}</template>
            <span>{{ docData.outsourcingRequisitionDocNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("全局搜索码") }}</template>
            <span>{{ docData.globalSearchNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("发料日期") }}</template>
            <span>{{
              formatDate(docData.baseRequisitionTime)
            }}</span> </el-descriptions-item
          ><el-descriptions-item>
            <template slot="label">{{ $t("开单人") }}</template>
            <span>{{ docData.baseDrawerName }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("收货确认人") }}</template>
            <span>{{ docData.baseConfirmmanName }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div style="margin: 10px 0; font-size: 16px; font-weight: bold; color: #1476C3">
        {{ $t("丨委外单信息") }}
      </div>
      <div style="margin-bottom: 10px">
        <el-descriptions
          direction="horizontal"
          :key="key"
          :size="'small'"
          :column="5"
          :label-style="labelStyle"
          :contentStyle="contentStyle"
          border
        >
          <el-descriptions-item>
            <template slot="label">{{ $t("委外单号") }}</template>
            <span>{{ routeQuery.outsourcingDocNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外产品编号") }}</template>
            <span>{{ routeQuery.materialNumber }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外产品名称") }}</template>
            <span>{{ routeQuery.materialName }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外产品规格") }}</template>
            <span>{{ specListShow(routeQuery.materialSpecDesc) }}</span>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">{{ $t("委外产品单位") }}</template>
            <span>{{ routeQuery.materialUnitName }}</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <!-- 内容 -->
      <div style="margin: 10px 0; font-size: 16px; font-weight: bold; color: #1476C3">
        {{ $t("丨发料信息") }}
      </div>
      <div>
        <myTable
          :key="materialTableKey"
          :overflow="true"
          :id="'myTableOne'"
          :columnType="'columnIndex'"
          :list="materialDetailList"
          :titleList="itemTitleList"
          :tableBtnList="itemTableBtnList"
          :dialogStatus="tableDialogStatus"
          @btnClick="productBtnClick"
          @inputNumberClick="inputNumberClick"
          @cellClickEvent="cellClickEvent"
          ref="myTableOne"
        ></myTable>
      </div>
      <div>
        <el-input
          type="textarea"
          disabled
          v-model="docData.remark"
          :placeholder="$t('备注')"
          rows="5"
        ></el-input>
      </div>
    </div>
    <receive-confirm-dialog
      :visible.sync="receiveDialogVisible"
      :requisition-doc-id="requisitionDocId"
      :source-detail-list="materialDetailList"
      :source-doc="docData"
      @success="handleReceiveSuccess"
    />
  </div>
</template>
<script>
import ReceiveConfirmDialog from "./receive_confirm_dialog.vue";
import { outsorRequisitionDoc_cancelReceiveConfirm, outsorRequisitionDoc_view } from "@/api/myController/outsourcing";
import {
  getMaterialRequisitionStatusLabel,
} from "@/utils/outsourcingMaterialRequisitionStatus";
import {
  buildCancelReceiveConfirmPayload,
  getRequisitionDocId,
  isSupplierConfirmedStatus,
  normalizeExceptionType,
  RECEIVE_EXCEPTION_TYPE,
  RECEIVE_EXCEPTION_TYPE_OPTIONS,
  resolveSupplierConfirmStatus,
  SUPPLIER_CONFIRM_STATUS,
} from "@/utils/outsourcingReceiveConfirm";
export default {
  components: {
    ReceiveConfirmDialog,
  },
  props: {
    routeType: {
      type: Array,
      default: undefined,
    },
    routeQuery: {
      default: () => ({}),
    },
    singleData: {
      default: () => ({}),
    },
    itemList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      homeLoading: false,
      receiveDialogVisible: false,
      cancelSubmitting: false,
      docData: {},
      outsorRequisitionDoc_view,
      materialDetailList: [],
      // ------------------------------
      itemTableBtnList: [],
      baseItemTitleList: [
        {
          id: 3,
          name: this.$t("物料编号"),
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 120,
        },
        {
          id: 4,
          name: this.$t("物料名称"),
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          canEdit: false,
          width: 120,
        },
        {
          id: 2,
          name: this.$t("规格型号"),
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          alwaysEditState: false,
          canEdit: false,
          width: 120,
        },
        {
          id: 2,
          name: this.$t("客户料号"),
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 120,
        },
        {
          id: 6,
          name: this.$t("单位"),
          value: "baseMaterialUnitName",
          dataType: "number",
          fixedState: false,
          isShow: true,
          canEdit: false,
          width: 120,
        },
        {
          id: 10,
          name: this.$t("申请数量"),
          value: "baseRequisitionQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          alwaysEditState: false,
          width: 120,
        },
        {
          id: 11,
          name: this.$t("备注"),
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "textarea",
          canEdit: false,
          alwaysEditState: false,
          width: 120,
        },
      ],

      // 标题样式
      labelStyle: {
        "text-align": "center",
        "font-size": "14px",
        "font-weight": "700",
        color: "#666",
        width: "120px",
        height: "42px !important",
        padding: "0 5px !important",
        "word-break": "keep-all",
      },
      contentStyle: {
        width: "220px",
        height: "42px !important",
        padding: "5px !important",
        "min-width": "120px",
      },
    };
  },
  computed: {
    requisitionDocId() {
      return getRequisitionDocId(this.docData);
    },
    materialRequisitionStatusLabel() {
      return getMaterialRequisitionStatusLabel(this.docData.statusMaterialRequisition);
    },
    supplierConfirmStatus() {
      return resolveSupplierConfirmStatus(this.docData, this.materialDetailList);
    },
    isSupplierConfirmed() {
      return isSupplierConfirmedStatus(this.docData, this.materialDetailList);
    },
    materialTableKey() {
      return `material-${this.supplierConfirmStatus ?? "unknown"}`;
    },
    tableDialogStatus() {
      return this.isSupplierConfirmed ? 1 : 0;
    },
    receiveConfirmItemTitleList() {
      return [
        {
          id: 20,
          name: this.$t("收料数量"),
          value: "valueActualReceiveQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          width: 100,
        },
        {
          id: 21,
          name: this.$t("批次号"),
          value: "valueBatchNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
        },
        {
          id: 22,
          name: this.$t("状态"),
          value: "valueExceptionType",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: RECEIVE_EXCEPTION_TYPE_OPTIONS,
          canEdit: false,
          width: 110,
        },
        {
          id: 23,
          name: this.$t("异常说明"),
          value: "valueExceptionRemark",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 160,
        },
        {
          id: 24,
          name: this.$t("异常附件"),
          value: "valueExceptionFileList",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 90,
        },
      ];
    },
    itemTitleList() {
      if (!this.isSupplierConfirmed) {
        return this.baseItemTitleList;
      }
      return [...this.baseItemTitleList, ...this.receiveConfirmItemTitleList];
    },
    canReceive() {
      const status = this.supplierConfirmStatus;
      if (status === undefined) return false;
      return (
        status === SUPPLIER_CONFIRM_STATUS.NONE ||
        status === SUPPLIER_CONFIRM_STATUS.PARTIAL
      );
    },
    canCancelReceive() {
      const status = this.supplierConfirmStatus;
      if (status === undefined) return false;
      return (
        status === SUPPLIER_CONFIRM_STATUS.PARTIAL ||
        status === SUPPLIER_CONFIRM_STATUS.COMPLETE
      );
    },
  },
  created() {
    this.getList();
  },
  methods: {
    // 多语言
    $t(value) {
      return value;
    },
    //
    getList() {
      this.homeLoading = true;
      outsorRequisitionDoc_view({
        outsourcingRequisitionDocId: this.routeQuery.outsourcingRequisitionDocId,
      }).then((res) => {
        const doc = res.data.data || {};
        const details = doc.outsorRequisitionDocDetailList || [];
        details.forEach((item) => {
          try {
            item.specifications = JSON.parse(item.baseSpecgroupDesc);
          } catch (error) {
            item.specifications = [];
          }
          item.valueMaterialQuantity = item.baseRequisitionQuantity;
          item.valueUnsendQuantity = item.valueUnrequisitionQuantity;
          item.valueBatchNumber = item.valueBatchNumber || "";
          item.valueExceptionRemark = item.valueExceptionRemark || "";
          item.valueExceptionType = item.valueExceptionType
            ? normalizeExceptionType(item.valueExceptionType)
            : RECEIVE_EXCEPTION_TYPE.NORMAL;
          if (doc.statusMaterialRequisition == null) {
            doc.statusMaterialRequisition = item.statusMaterialRequisition;
          }
        });
        const supplierConfirmStatus = resolveSupplierConfirmStatus(doc, details);
        if (supplierConfirmStatus !== undefined) {
          doc.statusSupplierConfirm = supplierConfirmStatus;
        }
        this.materialDetailList = details;
        this.docData = doc;
        this.syncRouteQueryStatus(supplierConfirmStatus);
        this.homeLoading = false;
      }).catch(() => {
        this.homeLoading = false;
      });
    },
    syncRouteQueryStatus(status) {
      if (status === undefined || !this.routeQuery) return;
      this.$set(this.routeQuery, "statusSupplierConfirm", status);
      if (Object.prototype.hasOwnProperty.call(this.routeQuery, "status_supplier_confirm")) {
        this.$set(this.routeQuery, "status_supplier_confirm", status);
      }
    },
    formatDate(time) {
      return this.$moment(time).format("YYYY-MM-DD"); // 获取当前时间
    },
    backHome() {
      this.$emit("backHome");
    },
    openReceiveDialog() {
      if (!this.requisitionDocId) {
        this.$message.warning(this.$t("缺少发料单标识，无法收料"));
        return;
      }
      if (!this.materialDetailList.length) {
        this.$message.warning(this.$t("暂无发料明细，无法收料"));
        return;
      }
      this.receiveDialogVisible = true;
    },
    handleReceiveSuccess() {
      this.getList();
    },
    handleCancelReceive() {
      const requisitionDocId = this.requisitionDocId;
      if (!requisitionDocId) {
        this.$message.warning(this.$t("缺少发料单标识，无法撤销收料"));
        return;
      }
      if (!this.canCancelReceive) {
        this.$message.warning(this.$t("当前状态无法撤销收料"));
        return;
      }
      this.$confirm(this.$t("是否确认撤销收料？"), this.$t("提示"), {
        type: "warning",
      })
        .then(() => {
          this.cancelSubmitting = true;
          return outsorRequisitionDoc_cancelReceiveConfirm(
            buildCancelReceiveConfirmPayload(requisitionDocId)
          );
        })
        .then(() => {
          this.$message.success(this.$t("撤销收料成功"));
          this.getList();
        })
        .catch(() => {})
        .finally(() => {
          this.cancelSubmitting = false;
        });
    },
    cellClickEvent(row, column) {
      switch (column.field) {
        default:
          break;
      }
    },
    specListShow(list) {
      try {
        list = JSON.parse(list);
      } catch (error) {
        list = [];
      }
      let text = "";
      try {
        for (let i = 0; i < list.length; i++) {
          let kong = i == list.length - 1 ? "" : "/";
          text += list[i].specKey + ":" + list[i].specValue + kong;
        }
      } catch (error) {}
      return text;
    },
  },
};
</script>
<style scoped>
.span {
  margin-right: 20px;
  color: #1476C3;
}
.input {
  width: 100%;
}

.btnOne {
  background: #1476C3;
  border-color: #1476C3;
  color: white;
  margin-left: 10px;
}

.btnCancel {
  border-color: #e6a23c;
  color: #e6a23c;
  margin-left: 10px;
}

::v-deep .btnCancel:hover,
::v-deep .btnCancel:focus {
  border-color: #cf9236;
  color: #cf9236;
  background: #fdf6ec;
}

::v-deep .btnOne:hover,
::v-deep .btnOne:focus {
  background: #1268ad;
  border-color: #1268ad;
  color: white;
}

.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
}

.title----font {
  color: #1476c3;
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}
.checkImg {
  height: 75px;
  width: 150px;
  position: absolute;
  top: 80px;
  right: 20px;
  z-index: 99;
  /* opacity: 0.5; */
  transform: rotate(-10deg);
}
</style>
